export const compose = (...funcs) => {
  if (funcs.length === 0) return arg => arg;
  if (funcs.length === 1) return funcs[0];
  return funcs.reduce((a, b) => (...args) => a(b(...args)));
};

export const combineReducers = reducers => (state = {}, action) => {
  const next = {};
  for (const [key, reducer] of Object.entries(reducers || {})) {
    next[key] = reducer(state[key], action);
  }
  return next;
};

export const createStore = reducer => ({
  getState: () => reducer(undefined, { type: '@@INIT' }),
  dispatch: () => {},
  subscribe: () => () => {},
});

export const applyMiddleware = () => arg => arg;
export default { compose, combineReducers, createStore, applyMiddleware };
